































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import MailingsRecipientDetails from "./MailingsRecipientDetails.vue";

import { ClientMailingJson } from "../../shared/ClientJson";
import MailingRecipientJson from "../../shared/MailingRecipientJson";
import MailingMessageRecipientInfoJson from "../../shared/MailingMessageRecipientInfoJson";
import { MailingRecipientStatus, MailingRecipientStatusNames } from "../../shared/MailingRecipientStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "MailingsMessageDetailsRecipients",
  components: {
    OverlayWindow,
    Loading,
    TableView,
    OnscreenMenu,
    MailingsRecipientDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    messageId: Number,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      MailingRecipientStatus: MailingRecipientStatus,
      MailingRecipientStatusNames: MailingRecipientStatusNames,
      UserPermissionRank: UserPermissionRank,
      allMessageRecipients: null as MailingMessageRecipientInfoJson[] | null,
      useFilters: false as boolean,
      filterIsPending: null as boolean | null,
      searchString: "" as string,
      showDetails: false,
      detailsMode: "read",
      detailsTitle: "",
      selectedRecipientId: null as number | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.loadMessageRecipients();
    },

    reloadData() {
      this.loadMessageRecipients();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterIsPending = null;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    async loadMessageRecipients() {
      if (this.messageId != null) {
        if (this.restClient != null) {
          try {
            this.allMessageRecipients = await this.restClient.getMailingMessageRecipientInfos(this.messageId);
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: MailingRecipientJson | null, mode: string) {
      if (item != null) {
        this.selectedRecipientId = item.ID;
      } else {
        this.selectedRecipientId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    async resentMessage(recipient: any) {
      if (this.messageId != null) {
        if (this.restClient != null) {
          this.loadingGeneral = true;

          try {
            await this.restClient.resendMailingMessageRecipientInfo(this.messageId, recipient.ID);

            this.loadingGeneral = false;
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        }
      }
    },

    /*** END: details view ***/

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "resentMessage") {
        this.resentMessage(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },

  watch: {},

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    filteredMessageRecipients(): MailingMessageRecipientInfoJson[] | undefined {
      if (this.allMessageRecipients != null) {
        var recipients: MailingMessageRecipientInfoJson[] = this
          .allMessageRecipients as MailingMessageRecipientInfoJson[];

        if (this.useFilters) {
          if (this.filterIsPending) {
            recipients = recipients.filter((i) => i.isDeliveryPending == true);
          }
        }

        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        /*
        for (var token of tokens) {
          recipients = recipients.filter(
            (i) => i.recipient?.item.contact?.firstName.toLowerCase().includes(token) || i.recipient?.item.contact?.toLowerCase().includes(token)
          );
        } */

        for (var token of tokens) {
          recipients = recipients.filter((i) => {
            if (i.recipient?.type == "ClientMailing") {
              if (
                i.recipient?.item.contact?.email.toLowerCase().includes(token) ||
                i.recipient?.item.contact?.firstName.toLowerCase().includes(token) ||
                i.recipient?.item.contact?.lastName.toLowerCase().includes(token)
              ) {
                return true;
              }
            } else if (i.recipient?.type == "Email") {
              if (i.recipient?.item.toLowerCase().includes(token)) {
                return true;
              }
            }

            return false;
          });
        }

        return recipients;
      }
    },

    messageRecipientsColumns: function (): TableViewColumnDefinitions<MailingMessageRecipientInfoJson>[] {
      let vue = this;

      return [
        {
          th: "E-Mail",
          td: (i) => {
            if (i.recipient?.type == "ClientMailing") {
              return i.recipient?.item.contact?.email ?? "--";
            } else if (i.recipient?.type == "Email") {
              return i.recipient.item ?? "--";
            } else {
              return "--";
            }
          },
        },
        {
          th: "Vorname",
          td: (i) => {
            if (i.recipient?.type == "ClientMailing") {
              return i.recipient?.item.contact?.firstName ?? "--";
            } else {
              return "--";
            }
          },
        },
        {
          th: "Nachname",
          td: (i) => {
            if (i.recipient?.type == "ClientMailing") {
              return i.recipient?.item.contact?.lastName ?? "--";
            } else {
              return "--";
            }
          },
        },
        {
          th: "Status",
          td: (i) => (i.isDeliveryPending ? "Versand ausstehend" : "Versendet"),
        },
        {
          th: "Versendet",
          td: (i) => (i.deliveryDate != null ? DateFormatter.formatDateTime(new Date(i.deliveryDate)) : ""),
        },
        {
          th: "",
          td: (i) => "Erneut senden",
          style: (i) => "text-align:right",
          button: "resentMessage",
        },
      ] as TableViewColumnDefinitions<MailingMessageRecipientInfoJson>[];
    },
  },
});
